//+++++++++++++++++++++++++++++++++++++++++++++++
// EASING FUNCTIONS
//+++++++++++++++++++++++++++++++++++++++++++++++
// All easing functions of https://goo.gl/N2rHTv
// have been adapted to vanilla js extensions of
// the CC.EasingFunctions Namespace. They can be
// easily used by requiring this file and the
// required easing function in the
// easing-functions folder
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.EasingFunctions = function() {
};

DW.EasingFunctions.prototype.easeInOutQuad = function(time, beginning, end, duration) {
  if((time/=duration/2) < 1) return end / 2 * time * time + beginning;
  return -end/2 * ((--time) * (time - 2) - 1) + beginning;
};
